export const convertCookieToExpired = (key: string) => {
    return `${key}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};
